import React from 'reactn';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import {
  withStyles,
  CircularProgress,
  Paper,
  Typography,
  Grid,
  Zoom,
  Slide,
  List,
  ListItem,
  Box
} from '@material-ui/core';
import { LineChart, ColumnChart } from 'react-chartkick';
import TOTUSERS from './Test/MockData';
import Datatable from 'material-table';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import SortIcon from '@material-ui/icons/Sort';
import FilterListIcon from '@material-ui/icons/FilterList';
import CompareIcon from '@material-ui/icons/Compare';
import UserTotModal from './UserTotModal';
import { withRouter } from '../../util/router-compatibility';
import { gettimeontask, getPermittedLocations, fetchJanusToken } from '../../util/APIUtils';
import TimerIcon from '@material-ui/icons/Timer';
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle';
import AvTimerIcon from '@material-ui/icons/AvTimer';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import { CustomChart } from '../chart';
import moment from 'moment';
import { DateRangePicker } from 'materialui-daterange-picker';
import { LOCATIONS, TOT_DETAILS_ENUM, setJanusToken, getJanusToken, CONTENT_AREA } from '../../constants';
import TotDetails from '../tot-details';
import Hoverable from '../hoverable';
import { UserIcon } from '../UserIcon';
import { isContentAreaExempted } from '../users/learner/transcript/utils';
import { connect } from 'react-redux';
import { setLocation as selectLocation, setHousingUnit as selectHousingUnit } from '../../v2/core/store/.';
import { theme as AdminTheme } from '../../v2/core/containers/theme';
import { UnleashService } from '../../v2/services';
import { withUnleash } from '../../v2/core/unleash';
import {
  toUtcInclusivePresetRange,
  resolveInclusiveCustomFilterDateRange,
  toDateRangePickerInitial
} from '../../util/dateRangeUtils';

///Styles Constants
const styles = theme => ({
  daysSelectionList: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 16
  },
  daysSelectionItem: {
    width: 'initial',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    height: 40,
    fontSize: 18,
    color: theme.palette.primary.cobalt,
    fontWeight: 'bold',
    '&:first-child': {
      borderTopLeftRadius: 20,
      borderBottomLeftRadius: 20
    },
    '&:last-child': {
      borderTopRightRadius: 20,
      borderBottomRightRadius: 20
    }
  },
  activeDay: {
    backgroundColor: theme.palette.primary.cobalt,
    color: 'white',
    '&:hover': {
      backgroundColor: theme.palette.primary.cobalt
    }
  },
  root: {
    padding: theme.spacing.unit * 2,
    flexGrow: 1
  },
  appBar: {
    background: 'white'
  },
  timeOnTaskChart: {
    height: 280,
    position: 'relative'
  },
  totBtn: {
    width: '100%'
  },
  summaryCard: {
    height: 280,
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'center'
  },
  locationCard: {
    height: 210,
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'center'
  },
  locationHeader: {
    width: '100%',
    flexGrow: 1,
    height: '30%',
    background: theme.palette.background.blue,
    padding: '.5rem'
  },
  locationFooter: {
    width: '100%',
    height: '70%',
    flexGrow: 1
  },
  statisticsContainer: {
    flex: 1,
    backgroundColor: theme.palette.colors.purpleMain, 
    margin: 6,
    color: 'white',
    borderRadius: 4
  },
  timeSpentContainer: {
    width: '100%',
    backgroundColor: theme.palette.colors.purpleMain, 
    margin: 6,
    color: 'white',
    borderRadius: 4
  }
});

const ONE_HOUR = 60 * 60 * 1000;

class Unit extends React.Component {
  isInclusiveTotDateRangeEnabled = () =>
    this.props.unleashProps?.getClient?.()?.isEnabled(UnleashService.FLAGS.INCLUSIVE_TOT_DATE_RANGE_FILTERS) ??
    false;

  columns = [
    {
      title: 'User Name',
      field: 'name',
      render: rowData => (
        <Hoverable title={rowData.name}>
          <Button
            color="primary"
            onClick={() => {
              this.setGlobal({ selectedUser: rowData.personId, openProfileView: true });
            }}
          >
            <UserIcon style={{ marginRight: 6 }} /> {rowData.name}
          </Button>
        </Hoverable>
      )
    },
    {
      title: 'DOC ID',
      field: 'docid',
      render: rowData => <Hoverable title={rowData.docid}>{rowData.docid}</Hoverable>
    },
    {
      title: 'Current Status',
      field: 'status',
      lookup: { active: 'active', inactive: 'inactive' },
      default: 'active',
      defaultSort: 'asc',
      render: rowData => (
        <Hoverable title={rowData.status}>
          <p style={{ color: rowData.status === 'active' ? 'black' : AdminTheme.palette.text.red }}>{rowData.status}</p>
        </Hoverable>
      )
    },
    {
      title: 'Total Time Spent (hours)',
      field: 'total',
      render: rowData => <Hoverable title={rowData.total.toFixed(2)}>{rowData.total.toFixed(2)}</Hoverable>
    },
    {
      title: 'Education',
      field: 'education',
      render: rowData => <Hoverable title={rowData.education.toFixed(2)}>{rowData.education.toFixed(2)}</Hoverable>
    },
    {
      title: 'Rehabilitation',
      field: 'rehab',
      render: rowData => <Hoverable title={rowData.rehab.toFixed(2)}>{rowData.rehab.toFixed(2)}</Hoverable>
    },
    {
      title: 'Workforce Skills',
      field: 'job',
      render: rowData => <Hoverable title={rowData.job.toFixed(2)}>{rowData.job.toFixed(2)}</Hoverable>
    },
    {
      title: 'Reentry',
      field: 'reentry',
      render: rowData => <Hoverable title={rowData.reentry.toFixed(2)}>{rowData.reentry.toFixed(2)}</Hoverable>
    },
    {
      title: 'Enrichment',
      field: 'enrichment',
      render: rowData => <Hoverable title={rowData.enrichment.toFixed(2)}>{rowData.enrichment.toFixed(2)}</Hoverable>
    },
    {
      title: 'Entertainment',
      field: 'entertainment',
      render: rowData => <Hoverable title={rowData.entertainment.toFixed(2)}>{rowData.entertainment.toFixed(2)}</Hoverable>
    },
    {
      title: 'Miscellaneous',
      field: 'misc',
      render: rowData => <Hoverable title={rowData.misc.toFixed(2)}>{rowData.misc.toFixed(2)}</Hoverable>
    }
  ];

  _chart = new CustomChart();
  state = {
    dateRangePicker: {
      isOpen: false
    },
    dateRange: this.global.selectedDateRange,
    userModalOpen: false,
    isLoading: false,
    isCustom: !!this.global.isCustomDateRange,
    totDetailsDialog: {
      isOpen: false
    },
    locationName: null,
    isTablePermitted: false,
    token: ''
  };

  async componentDidMount() {
    if (this.global.cbacConfigFlag) {
      await this.getPermittedLocations();
    } else {
      this.setState({
        isTablePermitted: true
      });
    }

    window.scrollTo(0, 0);
    await this.getData();
  }

  componentDidUpdate(prevProps, prevState) {
    this.getData();
    if (
      this.props.selectedHousingUnit &&
      prevProps.selectedHousingUnit !== this.props.selectedHousingUnit &&
      this.props.selectedLocation
    ) {
      const { selectedHousingUnit, selectedLocation } = this.props;
      this.props.history.push(
        `/outcomes-and-progress/${selectedLocation.locationName
          .split(' ')
          .join('-')
          .replace(/[^a-zA-Z0-9-_]/g, '')}/${selectedLocation.locationId}/${selectedHousingUnit.locationName
          .split(' ')
          .join('-')
          .replace(/[^a-zA-Z0-9-_]/g, '')}/${selectedHousingUnit.locationId}`
      );
      this.setState({
        locData: null
      });
    }
  }

  componentWillUnmount() {
    setJanusToken('');
  }

  getPermittedLocations = async () => {
    const permissionName = 'View_Individualized_Data_At_The_Hu_Level';
    const unitId = this.props.match.params.unitId;
    try {
      const locationId = this.props.match.params.locationId;
      const janusToken = getJanusToken();
      if (!janusToken) {
        const janusObj = await fetchJanusToken(locationId);
        setJanusToken(janusObj.token);
      }
      const units = await getPermittedLocations(locationId, permissionName);
      if (units.includes(parseInt(unitId))) {
        this.setState({ isTablePermitted: true });
      } else {
        this.setState({ isTablePermitted: false });
      }
    } catch {
      this.setState({ isTablePermitted: false });
    }
  };
  getData = () => {
    const { locData, isLoading } = this.state;
    if (locData || isLoading || LOCATIONS.length === 0) {
      return null;
    }
    var myFacilities = [this.selectedUnitId];
    this.setState({
      facilities: myFacilities,
      dateRange: this.global.selectedDateRange
    });
    let locationData = LOCATIONS.filter(l => {
      return l.locationId === this.selectedUnit && l.userDetails;
    }).filter(i => i.dateRange === this.global.selectedDateRange);

    var now = Date.now();
    if (locationData.length > 0 && now - locationData[0].timestamp <= ONE_HOUR * 12) {
      this.createTotViewData(locationData[0].data);
      this.setState({
        locData: locationData[0].data
      });
    } else {
      this.fetchTimeonTask(myFacilities);
    }
  };

  fake__componentWillReceiveProps() {
    var myFacilities = [this.selectedUnitId];
    this.setState({
      facilities: myFacilities,
      dateRange: this.global.selectedDateRange
    });
    let locationData = LOCATIONS.filter(l => {
      return l.locationId === this.selectedUnitId && l.userDetails;
    }).filter(i => i.dateRange === this.global.selectedDateRange);

    var now = Date.now();
    if (locationData.length > 0 && now - locationData[0].timestamp <= ONE_HOUR * 12) {
      this.createTotViewData(locationData[0].data);
      this.setState({
        locData: locationData[0].data
      });
    }
  }

  getDateRangeModelFromInteger = range => {
    var _range = range || this.state.dateRange;
    if (this.isInclusiveTotDateRangeEnabled()) {
      return toUtcInclusivePresetRange(_range);
    }
    const d = new Date();
    d.setDate(d.getDate() - _range);
    return {
      startDate: d.toISOString(),
      endDate: new Date().toISOString()
    };
  };

  getTimeonTask = async (fac, range, isDefiniteRange = true) => {
    this.setState({
      locData: null,
      isLoading: true
    });
    let filterDateRange = null;
    if (isDefiniteRange) {
      filterDateRange = this.getDateRangeModelFromInteger(range);
    } else {
      filterDateRange = range;
    }
    this.setGlobal({
      range: filterDateRange
    });
    let postBody = {
      requestorId: 169274,
      requestorLocationId: 1697386,
      filterLocationIds: fac,
      filterDateRange,
      retLearnerDetails: true
    };

    try {
      if (this.global.cbacConfigFlag) {
        await this.getPermittedLocations();
      }
      gettimeontask(postBody).then(data => {
        if (data.error) {
          this.setState({ error: data });
          return;
        }
        var facilitiesAverages = [];
        var facilityAve = [];
        data.locations.forEach(l => {
          facilityAve = [];
          var name = l.locationName;
          var ave = l.totalTimespent;
          facilityAve.push(name, ave);
          facilitiesAverages.push(facilityAve);
          var arr = [];
          var _arr = [];
          l.contentAreas.forEach(c => {
            if (isContentAreaExempted(c.contentAreaName)) {
              return;
            }
            _arr = [];
            var contentName = c.contentAreaName;
            var contentAve = c.totalTimespent;
            var id = c.contentAreaKey;
            _arr.push(contentName, contentAve, id);

            arr.push(_arr);
          });
          l.contentAverageChart = arr;
          data.contentAverageChart = l.contentAverageChart;
        });
        this.genTableData(data.locations[0].userDetails);
        this.genUserChart(data.locations[0].userDetails);
        data.facilityAverageChart = facilitiesAverages;
        var details = this.generateSummaryDetails(data.locations);
        data.totalTimespent = details.totalTimespent;
        data.numberOfUsers = details.numberOfUsers;
        data.averageTimespent = details.averageTimespent;
        this.setState({
          locData: data,
          isLoading: false
        });
        var globalLocationData = {
          locationId: this.selectedUnitId,
          dateRange: this.global.selectedDateRange,
          data: data,
          timestamp: Date.now()
        };
        var _globalDataStore = LOCATIONS;
        _globalDataStore.push(globalLocationData);
        this.setGlobal({
          locationDataStore: _globalDataStore
        });
      });
    } catch {
      /* fetch/cache failure: leave UI without updated store */
    }
  };

  createTotViewData(data) {
    var facilitiesAverages = [];
    var facilityAve = [];
    data.locations.forEach(l => {
      facilityAve = [];
      var name = l.locationName;
      var ave = l.totalTimespent;
      facilityAve.push(name, ave);
      facilitiesAverages.push(facilityAve);
      var arr = [];
      var _arr = [];
      l.contentAreas.forEach(c => {
        _arr = [];
        var contentName = c.contentAreaName;
        var contentAve = c.totalTimespent;
        var id = c.contentAreaKey;
        _arr.push(contentName, contentAve, id);

        arr.push(_arr);
      });
      l.contentAverageChart = arr;
    });
    this.genTableData(data.locations[0].userDetails);
    this.genUserChart(data.locations[0].userDetails);
    data.facilityAverageChart = facilitiesAverages;
    var details = this.generateSummaryDetails(data.locations);
    data.totalTimespent = details.totalTimespent;
    data.numberOfUsers = details.numberOfUsers;
    data.averageTimespent = details.averageTimespent;
  }

  genTableData(users) {
    var table = [];
    users.forEach(u => {
      var _user = {
        personId: u.personId,
        name: u.displayName,
        docid: u.docId,
        id: u.personId,
        enrichment: 0,
        education: 0,
        job: 0,
        misc: 0,
        person_key: 0,
        reentry: 0,
        entertainment: 0,
        rehab: 0,
        total: 0,
        status: u.currentStatusAtFacility
      };
      this._users = _user;
      u.contentAreas.forEach(c => {
        if (c.contentAreaName === 'Education') {
          this._users.education += c.totalTimespent;
        }
        if (c.contentAreaName === 'Enrichment') {
          this._users.enrichment += c.totalTimespent;
        }
        if (c.contentAreaName === 'Reentry') {
          this._users.reentry += c.totalTimespent;
        }
        if (c.contentAreaName === 'Rehabilitation') {
          this._users.rehab += c.totalTimespent;
        }
        if (c.contentAreaName === 'Miscellaneous') {
          this._users.misc += c.totalTimespent;
        }
        if (c.contentAreaName === 'Workforce Skills') {
          this._users.job += c.totalTimespent;
        }
        if (c.contentAreaName === 'Entertainment') {
          this._users.entertainment += c.totalTimespent;
        }
        this._users.total += c.totalTimespent;
      });
      table.push(_user);
    });
    this.setState({ totUserTableData: table });
  }

  generateSummaryDetails = loc => {
    var totalTimespent = 0;
    var numOfUsers = 0;
    var details = {};
    loc.forEach(l => {
      totalTimespent += l.totalTimespent;
      numOfUsers += l.numberOfUsers;
    });
    var ave = totalTimespent / numOfUsers;
    details.averageTimespent = ave.toFixed(1);
    details.totalTimespent = totalTimespent.toFixed(2);
    details.numberOfUsers = numOfUsers;
    return details;
  };

  /**
   * @name handleToTDetailsDialog
   * @param {boolean} isOpen
   * @desc Handles time on task dialog open flag.
   * @return {void}
   */
  handleToTDetailsDialog = isOpen => {
    this.setState({
      totDetailsDialog: {
        ...this.state.totDetailsDialog,
        isOpen
      }
    });
  };

  genUserChart(users) {
    var chartData = [];
    users.forEach(u => {
      var user = { name: u.displayName, data: {} };
      u.contentAreas.forEach(c => {
        if (isContentAreaExempted(c.contentAreaName)) {
          return;
        }
        c.timeOnTaskList.forEach(t => {
          user.data[t.date] = t.timespent;
        });
      });
      chartData.push(user);
    });
    this.setState({ allUsers: chartData });
  }

  handleClose = () => {
    this.setGlobal({
      openUnitView: false
    });
  };

  handleCloseUserModal = () => {
    this.setState({
      userModalOpen: false
    });
  };

  getUnique(arr, comp) {
    //store the comparison  values in array
    const unique = arr
      .map(e => e[comp])
      // store the keys of the unique objects
      .map((e, i, final) => final.indexOf(e) === i && i)
      // eliminate the dead keys & return unique objects
      .filter(e => arr[e])
      .map(e => arr[e]);
    return unique;
  }

  filterUser(id) {
    var _tot = TOTUSERS.filter((a, ind) => {
      return a.person_key === id;
    });
    return _tot;
  }

  tableToChart(arr) {
    arr.forEach(u => {
      var user = {};
      user.name = u.name;
      for (var key in u) {
        if (!Object.hasOwn(u, key)) continue;

        var obj = u[key];
        for (var prop in obj) {
          if (!Object.hasOwn(obj, prop)) continue;
        }
      }
    });
  }

  get selectedUnitId() {
    let unitId = this.props.match.params.unitId;
    return unitId.split('&')[0];
  }

  get selectedUnitName() {
    return this.props.match.params.unitName;
  }

  handleChange = value => {
    this.setState({
      dateRange: value,
      isCustom: false
    });
    var range = value;
    let locationData = LOCATIONS.filter(l => {
      return l.locationId === this.selectedUnitId && l.userDetails;
    }).filter(i => i.dateRange === range);
    var now = Date.now();
    if (locationData.length > 0 && now - locationData[0].timestamp <= ONE_HOUR * 12) {
      this.createTotViewData(locationData[0].data);
      this.setState({
        locData: locationData[0].data
      });
      this.setGlobal({
        selectedDateRange: range,
        range: this.getDateRangeModelFromInteger(range),
        isCustomDateRange: false
      });
    } else if (locationData.length <= 0) {
      var fac = this.state.facilities;
      this.setGlobal({
        selectedDateRange: range,
        range: this.getDateRangeModelFromInteger(range),
        isCustomDateRange: false
      });
      this.getTimeonTask(fac, range);
    }
  };

  getUserTot(user) {
    var _data = this.state.locData.locations[0].userDetails.filter(u => {
      return u.personId === user;
    });

    this.setState({
      userModalOpen: true,
      selectedUser: _data
    });
  }

  fetchTimeonTask = fac => {
    if (this.isInclusiveTotDateRangeEnabled() && this.global.isCustomDateRange) {
      this.getTimeonTask(fac, this.global.range, false);
    } else if (![7, 30, 90, 365].includes(this.global.selectedDateRange)) {
      this.getTimeonTask(fac, this.global.range, false);
    } else {
      this.getTimeonTask(fac, this.global.selectedDateRange);
    }
  };

  handleDateRangePicker = isOpen => {
    this.setState({
      dateRangePicker: {
        ...this.state.dateRangePicker,
        isOpen
      }
    });
  };

  handleDateRangeChange = range => {
    if (this.isInclusiveTotDateRangeEnabled()) {
      const { formattedRange, daysCount } = resolveInclusiveCustomFilterDateRange(range);
      this.setGlobal({
        selectedDateRange: daysCount,
        range: formattedRange,
        isCustomDateRange: true
      });
      this.setState({
        dateRange: daysCount,
        isCustom: true
      });
      this.handleDateRangePicker(false);
      this.getTimeonTask(this.state.facilities, formattedRange, false);
      return;
    }

    range = {
      startDate: moment.utc(range.startDate),
      endDate: moment.utc(range.endDate)
    };
    const daysCount = moment.duration(range.endDate.diff(range.startDate)).asDays();

    const formattedRange = {
      startDate: range.startDate.format(),
      endDate: range.endDate.format()
    };
    this.setGlobal({
      selectedDateRange: daysCount,
      range: formattedRange,
      isCustomDateRange: true
    });
    this.setState({
      dateRange: daysCount,
      isCustom: true
    });
    this.handleDateRangePicker(false);
    this.handleDateRangePicker(false);
    var fac = this.state.facilities;
    this.getTimeonTask(
      fac,
      {
        startDate: moment.utc(range.startDate).format(),
        endDate: moment.utc(range.endDate).format()
      },
      false
    );
  };

  dayRangeListItemClass(classes, dayValue) {
    return [
      classes.daysSelectionItem,
      this.global.selectedDateRange === dayValue && !this.state.isCustom ? classes.activeDay : null
    ].join(' ');
  }

  renderDateRangeSelector() {
    const { classes } = this.props;
    const initialDateRange = toDateRangePickerInitial(this.global.range);
    const pickerKey = initialDateRange
      ? `${initialDateRange.startDate.getTime()}-${initialDateRange.endDate.getTime()}`
      : 'preset';
    return (
      <Box display="flex" alignItems="center" justifyContent="center" position="relative" className={classes.actionBar}>
        <List className={classes.daysSelectionList}>
          <ListItem button onClick={() => this.handleChange(7)} className={this.dayRangeListItemClass(classes, 7)}>
            7 Days
          </ListItem>
          <ListItem button onClick={() => this.handleChange(30)} className={this.dayRangeListItemClass(classes, 30)}>
            30 Days
          </ListItem>
          <ListItem button onClick={() => this.handleChange(90)} className={this.dayRangeListItemClass(classes, 90)}>
            90 Days
          </ListItem>
          <ListItem button onClick={() => this.handleChange(365)} className={this.dayRangeListItemClass(classes, 365)}>
            365 Days
          </ListItem>
          <ListItem
            onClick={() => this.handleDateRangePicker(true)}
            button
            className={[classes.daysSelectionItem, this.state.isCustom ? classes.activeDay : null].join(' ')}
          >
            Custom
          </ListItem>
        </List>
        <Box position="absolute" top="0px">
          {this.state.dateRangePicker.isOpen && (
            <DateRangePicker
              key={pickerKey}
              open={true}
              closeOnClickOutside={true}
              maxDate={new Date()}
              initialDateRange={initialDateRange}
              toggle={() => this.handleDateRangePicker(!this.state.dateRangePicker.isOpen)}
              onChange={this.handleDateRangeChange}
            />
          )}
        </Box>
      </Box>
    );
  }

  renderTimeOnTaskChart(classes) {
    if (this.state.totData && this.state.totData.length > 0 && this.state.totData.length < 15) {
      return (
        <Slide in unmountOnExit direction="left">
          <Paper className={classes.timeOnTaskChart}>
            <Typography variant="h6" style={{ textAlign: 'center', padding: '.5rem', fontSize: 18 }}>
              Users Time on Task
            </Typography>
            <LineChart
              library={{
                ...this._chart.getDefaultOptions,
                legend: {
                  display: true
                }
              }}
              ytitle="Time Spent (hours)"
              height={220}
              stacked
              adapter="chartjs"
              data={this.state.totData}
            />
          </Paper>
        </Slide>
      );
    }

    if (this.state.locData) {
      return (
        <Zoom in unmountOnExit>
          <Paper className={classes.timeOnTaskChart}>
            <Typography variant="h6" style={{ textAlign: 'center', padding: '.5rem', fontSize: 18 }}>
              Time on Task by Pathways
            </Typography>
            {this.state.locData.contentAverageChart && this.state.locData.contentAverageChart.length > 0 && (
              <ColumnChart
                dataset={{
                  ...this._chart.getDefaultDatasetOptions,
                  backgroundColor: this.state.locData.contentAverageChart.map(data =>
                    CONTENT_AREA[data[2]] ? CONTENT_AREA[data[2]].bgColor : AdminTheme.palette.background.blue
                  )
                }}
                library={this._chart.getDefaultOptions}
                stacked
                ytitle="Time Spent (hours)"
                height={220}
                adapter="chartjs"
                data={this.state.locData.contentAverageChart}
              />
            )}
          </Paper>
        </Zoom>
      );
    }

    return null;
  }

  render() {
    const { classes } = this.props;

    return (
      <div style={{ padding: '1rem' }}>
        {this.renderDateRangeSelector()}
        {this.state.error && (
          <div>
            <h3>An error has occured.</h3>
            <h5>{this.state.error.error}</h5>
            <p>{this.state.error.error_description}</p>
          </div>
        )}

        <Grid container spacing={24}>
          {this.state.locData ? (
            <Grid item sm={3} xs={12}>
              <Zoom in unmountOnExit>
                <div style={{ display: 'flex', flex: 1, flexFlow: 'row wrap' }}>
                  <div style={{ flex: 1, display: 'flex', flexFlow: 'row wrap' }}>
                    <Paper style={{ width: '100%', borderRadius: 4, margin: 4 }}>
                      <Typography variant="h6" style={{ margin: 10, color: AdminTheme.palette.text.navy }}>
                        {this.selectedUnitName}
                      </Typography>
                    </Paper>
                    <Paper className={classes.statisticsContainer} >
                      <AvTimerIcon style={{ width: 18, height: 18, float: 'left', margin: 4 }} />
                      <p style={{ textAlign: 'left', margin: 6, marginTop: 3 }}> average</p>
                      <Typography variant="h5" style={{ margin: 8, textAlign: 'center', color: 'white' }}>
                        {this.state.locData.averageTimespent || 0}
                      </Typography>
                    </Paper>
                    <Paper className={classes.statisticsContainer}>
                      <SupervisedUserCircleIcon style={{ width: 18, height: 18, float: 'left', margin: 4 }} />
                      <p style={{ textAlign: 'left', margin: 6, marginTop: 3 }}> users</p>
                      <Typography variant="h5" style={{ margin: 8, color: 'white', textAlign: 'center' }}>
                        {this.state.locData.numberOfUsers}
                      </Typography>
                    </Paper>
                    <Paper className={classes.timeSpentContainer}>
                      <TimerIcon style={{ width: 22, height: 22, float: 'left', margin: 4 }} />
                      <p style={{ textAlign: 'left', margin: 6, marginTop: 7 }}> total hours spent</p>
                      <Typography variant="h6" style={{ margin: 10, color: 'white', textAlign: 'center' }}>
                        {this.state.locData.totalTimespent}
                      </Typography>
                    </Paper>
                    {this.state.isTablePermitted && (
                      <Button className={classes.totBtn} color="primary" onClick={() => this.handleToTDetailsDialog(true)}>
                        View Time On Task Details
                      </Button>
                    )}
                    <TotDetails
                      contentAreaVisible
                      exportFileName={this.selectedUnitName}
                      heading={`${this.selectedUnitName} Time on Task`}
                      locations={this.state.locData.locations}
                      open={this.state.totDetailsDialog.isOpen}
                      type={TOT_DETAILS_ENUM.Location}
                      closeHandler={this.handleToTDetailsDialog}
                      locationType="HU"
                      parentLocationId={this.props.match.params.locationId}
                    />
                  </div>
                </div>
              </Zoom>
            </Grid>
          ) : (
            <Paper style={{ padding: '1rem', width: '100%' }}>
              <CircularProgress className={classes.progress} />
              <h1>Loading time on task data...</h1>
            </Paper>
          )}
          <Grid item sm={9} xs={12}>
            {this.renderTimeOnTaskChart(classes)}
          </Grid>
        </Grid>
        {this.state.allUsers ? (
          <div>
            {this.state.locData && this.state.isTablePermitted ? (
              <Zoom in unmountOnExit>
                <Paper style={{ marginTop: '2rem' }}>
                  <p style={{ margin: '1rem', marginTop: '1rem' }}>
                    Select up to 15 learners to see their time on task details above.
                  </p>
                  <Datatable
                    title={`${this.selectedUnitName} Time on Task`}
                    data={this.state.totUserTableData}
                    columns={this.columns}
                    icons={{
                      Search: SearchIcon,
                      ResetSearch: CloseIcon,
                      FirstPage: FirstPageIcon,
                      LastPage: LastPageIcon,
                      NextPage: NavigateNextIcon,
                      PreviousPage: NavigateBeforeIcon,
                      Filter: FilterListIcon,
                      Sort: SortIcon,
                      SortArrow: ArrowDownwardIcon,
                      Export: SaveAltIcon,
                      Edit: EditIcon,
                      User: <UserIcon />
                    }}
                    options={{
                      pageSize: 20,
                      selection: true,
                      sorting: true,
                      exportButton: true,
                      exportAllData: true,
                      rowStyle: rowData => ({
                        backgroundColor: rowData.status === 'active' ? '#ffffff' : '#e8e8e8'
                      })
                    }}
                    onSelectionChange={rows => {
                      var chartArr = [];
                      var _chartData = this.state.allUsers;
                      rows.forEach(r => {
                        if (_chartData !== null) {
                          var user = _chartData.filter(o => o.name === r.name);
                          user.forEach(u => chartArr.push(u));
                        }
                      });
                      this.setState({
                        totData: chartArr
                      });
                    }}
                    actions={[
                      {
                        icon: CompareIcon,
                        onClick: (event, rowData) => {
                          var arr = Object.keys(rowData).map(key => rowData[key]);
                          this.tableToChart(arr);
                          this.setState({
                            selectedUsers: arr
                          });
                        }
                      }
                    ]}
                  />
                </Paper>
              </Zoom>
            ) : null}
          </div>
        ) : null}
        {this.state.userModalOpen && this.state.selectedUser ? (
          <UserTotModal user={this.state.selectedUser} open={this.state.userModalOpen} close={this.handleCloseUserModal} />
        ) : null}
      </div>
    );
  }
}

Unit.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return state.app;
};

const mapDispatchToProps = dispatch => {
  return {
    selectLocation: location => dispatch(selectLocation(location)),
    selectHousingUnit: hu => dispatch(selectHousingUnit(hu))
  };
};

export default withUnleash(
  connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withRouter(Unit))),
  UnleashService.FLAGS.INCLUSIVE_TOT_DATE_RANGE_FILTERS
);
